// import "babel-polyfill";
import "./loadCssSpit";
import util from "./_util/util";
import * as History from "./history-3.3.0/modules/index";
import middleware from "./middleware";

import "./_rc-steps-3.0.1/assets/index.less";
import "./_rc-pagination-1.5.3/assets/index.less";
window.History = History;

const req = require.context(
  "./_antd1.11.2",
  true,
  /^\.\/[^_][\w-]+\/(style\/)?index\.jsx?$/
);
req.keys().forEach(mod => {
  const v = req(mod);
  const match = mod.match(/^\.\/([^_][\w-]+)\/index\.jsx?$/);
  if (match && match[1]) {
    let name = match[1];
    if (match[1] === "message" || match[1] === "notification") {
    } else {
      name = util.camelCase(name);
    }
    // v.default = util.tryCatch(React, MyErrorHandler, {error: "前端组件库异常，请联系管理员!"})(v.default);
    // exports[name] = v.default;
    exports[name] = middleware(v, name);
  }
});



// WEBPACK FOOTER //
// ./_antd.js